import { render, staticRenderFns } from "./xy-modal-container-design.vue?vue&type=template&id=c70175b8"
import script from "./xy-modal-container-design.vue?vue&type=script&lang=js"
export * from "./xy-modal-container-design.vue?vue&type=script&lang=js"
import style0 from "./xy-modal-container-design.vue?vue&type=style&index=0&id=c70175b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports